import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import Header from './header';
import { getObituaryLink, getVenueType } from '~/selectors/event';
const HeaderContainer = (props) => _jsx(Header, { ...props });
const mapStateToProps = (state) => ({
    logo: state.event.data.venue.logo_full,
    venueId: state.event.data.venue.id,
    venueType: getVenueType(state),
    obituaryLink: getObituaryLink(state),
});
export default connect(mapStateToProps)(HeaderContainer);
